import { useSectionStates } from '@/features/kyc/hooks/useSectionStates';
import { IUser } from '@/features/user/store/user.model';
import { BusinessMainInformation } from '@/features/kyc/components/userInformation/businessUser/BusinessMainInformation';
import { BusinessVerificationDetail } from '@/features/kyc/components/userInformation/businessUser/BusinessVerificationDetail';
import { TBusinessSectionKey } from '@/features/kyc/store/types/business.types';

export interface IBusinessUserProps {
  user: IUser;
  parentUser?: IUser;
}

export function BusinessUser({ user }: IBusinessUserProps) {
  const { toogleSectionEditMode, isSectionEditable, isSectionOnEdition } = useSectionStates<TBusinessSectionKey>([
    'mainInformation',
    'contact',
    'situation',
    'taxResidence',
  ]);

  return (
    <>
      <BusinessMainInformation
        user={user}
        isSectionOnEdition={isSectionOnEdition}
        isSectionEditable={isSectionEditable}
        toogleSectionEditMode={toogleSectionEditMode}
      />
      <BusinessVerificationDetail
        user={user}
        isSectionOnEdition={isSectionOnEdition}
        isSectionEditable={isSectionEditable}
        toogleSectionEditMode={toogleSectionEditMode}
      />
    </>
  );
}
